<template>
  <el-dialog
    :visible.sync="showEdit"
    width="50%"
    :append-to-body="true"
    @open="handleOpen"
    :modal-append-to-body="true"
    destroy-on-close
    title="看吧发布"
    @closed="handleClose"
    :close-on-click-modal="false"
    class="view-video"
  >
    <el-form ref="form" :model="form" label-position="top" :rules="rules">
      <el-row>
        <el-col  :span="12">
          <el-form-item style="margin-top: -25px" prop="title" label="请填写报告标题">
            <el-input  size="mini" v-model="form.title" type="text" :rows="1" :maxlength="18" placeholder="请填写报告标题" show-word-limit />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item style="margin-top: -10px" label="请填写报告内容" prop="content">
            <el-input
              type="textarea"
              size="mini"
              :maxlength="360"
              show-word-limit
              placeholder="请填写报告内容"
              :autosize="{minRows: 4}"
              v-model="form.content">
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item style="margin-top: -10px" label="请上传媒体文件" prop="video_url">
            <love-element-upload

              :list-type="mediaUploadOptions.listType"
              :drag="mediaUploadOptions.drag"
              :allow-type="mediaUploadOptions.allowType"
              :allow-size="mediaUploadOptions.allowSize"
              :disabled="mediaUploadOptions.disabled"
              :limit="mediaUploadOptions.limit"
              :multiple="mediaUploadOptions.multiple"
              :love-path="mediaUploadOptions.lovePath"
              :file-list="fileList.video"
              :video-duration="mediaUploadOptions.videoDuration"
              :accept="mediaUploadOptions.accept"
              :show-file-list="mediaUploadOptions.showFileList"
              @preview="onPreviewMedia"
              @remove="onRemoveMedia"
              @success="onSuccessMedia">
            </love-element-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item style="margin-top: -5px">
            <love-element-upload
              :list-type="thumbUploadOptions.listType"
              :drag="thumbUploadOptions.drag"
              :allow-type="thumbUploadOptions.allowType"
              :allow-size="thumbUploadOptions.allowSize"
              :disabled="thumbUploadOptions.disabled"
              :limit="thumbUploadOptions.limit"
              :multiple="thumbUploadOptions.multiple"
              :love-path="thumbUploadOptions.lovePath"
              :file-list="fileList.thumb"
              :video-duration="thumbUploadOptions.videoDuration"
              :accept="thumbUploadOptions.accept"
              :bottom-text="thumbUploadOptions.bottomText"
              :show-file-list="true"
              :tips="thumbUploadOptions.tips"
              @preview="onPreviewThumb"
              @remove="onRemoveThumb"
              @success="onSuccessThumb" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item  label="报告人姓名">
        <el-row>
          <el-col :span="12">
            <el-input
              size="mini"
              v-model="form.author_name"
              placeholder="请输入报告人姓名" show-word-limit/>
          </el-col>
        </el-row>
<!--        <el-autocomplete-->
<!--          v-model="form.author_name"-->
<!--          placeholder="请输入报告人姓名"-->
<!--          clearable-->
<!--          :fetch-suggestions="querySearchUser"-->
<!--          @select="onSelectLectureAuthor"-->
<!--          @clear="onClearSelectAuthor">-->
<!--        </el-autocomplete>-->
      </el-form-item>
      <el-form-item style="margin-top: -20px" label="上传报告人头像">
        <d2-avatar-uploader
          v-model="form.author_avatar"
          @on-success="onChangeAvatar" />
      </el-form-item>
      <el-row>
        <el-col :span="12">
          <el-form-item style="margin-top: -20px" label="报告人简介">
            <el-input
              type="textarea"
              placeholder="请填写报告人简介"
              :autosize="{minRows: 4}"
              v-model="form.author_summary"
              maxlength="200"
              show-word-limit>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer">
      <el-button size="medium" type="info" @click="handleClose">取消</el-button>
      <axj-button color="#00adb5" size="max" @click="handleSubmit">保存</axj-button>
    </div>
  </el-dialog>
</template>

<script>



const defaultForm = {
  id: undefined,
  main_tag_id: undefined,
  user_id: undefined,
  user_name: '',
  user_avatar: '',
  author_id: undefined,
  author_name: '',
  author_avatar: '',
  title: '',
  content: '',
  thumb: '',
  video_url: '',
  duration: undefined,
  is_comment: 0,
  create_ip: '',
  update_ip: '',
  source_directory: undefined,
  status: 0
}
import { fetchLecturehallSpeech, createLecturehallSpeech, updateLecturehallSpeech } from '@/api/axj-information/axj-information-view-club'
export default {
  name: "view-club-edit",
  props:{
    show:{
      type:Boolean,
      default:false
    },
    isCreate: {
      type: Boolean,
      default: false
    },
    viewId:{
      type: Number,
      default: 0
    }
  },
  watch:{
    show(v){
      this.showEdit=v
    }
  },
  data(){
    return{
      showEdit:false,
      // 记录报告唯一id
      id: undefined,
      form: Object.assign({}, defaultForm),
      // love element upload 上传文件组件参数
      mediaUploadOptions: {
        listType: "text",
        allowType: ["video/mp4"],
        drag: true,
        disabled: false,
        limit: 1,
        allowSize: 200,
        accept: '.mp4',
        multiple: false,
        videoDuration: true,
        lovePath:{
          module: "extra/lecturehall/speech",
          source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
      },
      thumbUploadOptions: {
        listType: "picture",
        allowType: ["image/jpg", "image/jpeg", "image/png"],
        drag: false,
        disabled: false,
        limit: 1,
        allowSize: 20,
        accept: 'image/*',
        multiple: false,
        videoDuration: true,
        bottomText: "设置封面",
        tips: "视频封面",
        lovePath:{
          module: "extra/lecturehall/speech/thumb",
          source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
      },
      // fileList
      fileList: {
        video: [],
        thumb: []
      },
      // web view preview
      webPreview: false,
      // loading
      loading: false,
      // 数据验证
      rules: {
        title: [
          { required: true, message: '请填写报告标题', trigger: 'change' }
        ],
        video_url: [
          { required: true, message: '请上传视频报告', trigger: 'blur,change' }
        ],
        content: [
          { required: true, message: '请填写报告内容', trigger: 'change' }
        ],
        author_id: [
          { required: true, message: '请选择用户', trigger: 'change' }
        ]
      },
    }
  },
  methods:{
    handleClose(){
      this.form=Object.assign({}, defaultForm)
      this.fileList={
        video:[],
        thumb:[]
      }
      this.thumbUploadOptions={
        listType: "picture",
          allowType: ["image/jpg", "image/jpeg", "image/png"],
          drag: false,
          disabled: false,
          limit: 1,
          allowSize: 20,
          accept: 'image/*',
          multiple: false,
          videoDuration: true,
          bottomText: "设置封面",
          tips: "视频封面",
          lovePath:{
          module: "extra/lecturehall/speech/thumb",
            source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
      }

      this.mediaUploadOptions={
        listType: "text",
          allowType: ["video/mp4"],
          drag: true,
          disabled: false,
          limit: 1,
          allowSize: 200,
          accept: '.mp4',
          multiple: false,
          videoDuration: true,
          lovePath:{
          module: "extra/lecturehall/speech",
            source_directory: "",  // this.uid + '_' + Date.parse(new Date()) / 1000
        },
      }
      this.$refs['form'].clearValidate();
      this.$emit("update:show",false)
    },
    handleGetSpeechData(id) {
      fetchLecturehallSpeech(id)
        .then(res=> {
          const data = res.data
          // 常规数据
          console.log(data)
          this.form = Object.assign({},this.defaultForm, data)
          // 去掉form中的多余属性
          this.$delete(this.form,'created_at')
          this.$delete(this.form,'deleted_at')
          this.$delete(this.form,'updated_at')
          this.$delete(this.form,'Count')
          this.$delete(this.form,'MainTag')
          // 若数据库中已经存放了该报告的 source directory
          if (data.source_directory != '') {
            // mediaUploadOptions 中也使用该 source directory
            this.mediaUploadOptions.lovePath.source_directory = data.source_directory
          }
          // 处理作者头像信息
          this.form.author_avatar = this.formatUrl(data.author_avatar)
          // 把封面展示
          if(data.thumb) {
            this.fileList.thumb = []
            console.log("封面", data.thumb, this.fileList.thumb)
            this.fileList.thumb.push({
              name: "视频封面",
              url: data.thumb.indexOf('http')>=0?data.thumb:this.resourcePrefix.url + data.thumb,
              type: "image",
              status: "success"
            })
            console.log("封面", data.thumb, this.fileList.thumb)
          }
          // 判断是否有视频
          if(data.video_url) {
            const regx = /([^/]+)$/
            const videoname = data.video_url.match(regx)
            // 是否有前缀
            let video = {
              name: videoname[1],
              url: data.video_url.indexOf('http')>=0?data.video_url:this.resourcePrefix.url + data.video_url,
              type: "video",
              status: "success"
            }
            this.fileList.video.push(video)
          }
        })
    },
    onChangeAvatar(val) {
      this.form.author_avatar = val
    },
    onSelectLectureAuthor(val) {
      // 作者头像为空且当前头像与真实头像不一致时提示
      if(this.form.author_avatar!='' && this.form.author_avatar!=this.formatUrl(val.data.real_avatar)) {
        this.$confirm('检测到报告人头像不一致，是否替换现有报告人头像? ', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.form.author_id = val.id
          this.form.author_avatar = this.formatUrl(val.data.real_avatar)
        }).catch(() => {
          this.form.author_id = val.id
        })
      } else {
        this.form.author_id = val.id
        this.form.author_avatar = this.formatUrl(val.data.real_avatar)
      }
    },
    onClearSelectAuthor() {
      this.form.author_id = 0
      this.form.author_name = ''
      this.form.author_avatar = ''
    },
    onPreviewThumb(file) {
      console.log(file)
      console.log(this.fileList)
    },
    onRemoveThumb(file, fileList) {
      this.form.thumb = ''
      this.fileList.thumb = []
    },
    onSuccessThumb(response) {
      // 保存返回值
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        status: "success"
      }
      this.fileList.thumb[0] = file
      this.form.thumb = response.url
    },

    onPreviewMedia(file) {
      console.log(file)
      console.log(this.fileList)
    },
    onRemoveMedia(file, fileList) {
      this.form.video_url = ''
      this.form.thumb = ''
      this.fileList.video = []
      this.fileList.thumb = []
    },
    onSuccessMedia(response) {
      // 保存返回值
      const file = {
        uid: response.uid,
        name: response.old_name,
        url: response.url,
        duration: response.duration * 1000,  // 秒转换为毫秒,
        status: "success"
      }
      this.fileList.video[0] = file
      this.form.video_url = response.url
      this.form.thumb = response.url+"?spm=a2c4g.11186623.2.1.yjOb8V&x-oss-process=video/snapshot,t_0,f_jpg"
      this.fileList.thumb = []
      this.fileList.thumb.push({
        name: "视频封面",
        url: this.form.thumb,
        type: "image",
        status: "success"
      })
      this.form.duration = response.duration  * 1000  // 秒转换为毫秒
    },

    onSelectUser(val) {
      if(val.id) {
        this.form.author_id = val.id
        this.form.author_name = val.realname
        this.form.author_avatar = val.avatar
      } else {
        this.form.author_id = undefined
        this.form.author_name = ''
        this.form.author_avatar = ''
      }
    },
    handleSubmit(status) {
      // 表单校验
      this.$refs['form'].validate(async (valid) => {
        if(valid) {
          // 补充表单信息
          this.form.status = status
          // mediaUploadOptions.lovePath.source_directory 中保存的为报告的 source_directory
          this.form.source_directory = this.mediaUploadOptions.lovePath.source_directory
          // 去掉URL前缀
          this.form.video_url = this.sliceUrl(this.form.video_url)
          this.form.thumb = this.sliceUrl(this.form.thumb)
          // 作者头像去前缀
          this.form.author_avatar = this.sliceUrl(this.form.author_avatar)
          // 创建报告时
          if(this.isCreate) {
            this.form.user_id = this.info.id
            this.form.user_name = this.info.nickname
            this.form.user_avatar = this.info.avatar
            await this.handleCreateSpeech(this.form)
            this.$nextTick(()=> {
              this.$emit("success")
            })
          } else {
            await this.handleUpdateSpeech(this.form)
            await this.handleUpdateSpeechStatus(this.form)
            this.$nextTick(()=> {
              this.$emit("success")
            })
          }
        }
      })
      console.log(this.form)
    },
    handleCloseSubmit() {
      // 取消修改
      this.$nextTick(()=> {
        this.$router.go(-1)
      })
    },
    handleCreateSpeech(form) {
      return new Promise((resolve, reject)=> {
        this.loading = true
        createLecturehallSpeech(form)
          .then(res=> {
            this.$notify({
              message: form.status == 0 ? '保存成功!' : '报告已成功发布!',
              type: 'success',
              duration: 2000
            })
            this.loading = false
            resolve(res)
          })
          .catch(err=> {
            this.$notify.error({
              message: '报告发布失败，请重试!',
              duration: 2000
            })
            this.loading = false
            reject(err)
          })
      })
    },
    handleUpdateSpeech(form) {
      return new Promise((resolve, reject)=> {
        // 修改报告内容
        this.loading = true
        updateLecturehallSpeech(form)
          .then(res=> {
            resolve(res)
          })
          .catch(err=> {
            reject(err)
          })
      })
    },
    handleUpdateSpeechStatus(form) {
      return new Promise((resolve, reject)=> {
        // 如果 thumb_sum 等从 非0 再修改为 0 的时候就需要用 where 修改了
        updateLecturehallSpeech({
          id: form.id,
          where: JSON.stringify({
            ...form
          })
        })
          .then(res=> {
            this.$notify({
              message: form.status == 0 ? '保存成功!' : '报告修改成功!',
              type: 'success',
              duration: 2000
            })
            this.loading = false
            resolve(res)
          })
          .catch(err=> {
            this.$notify.error({
              message: '修改报告失败，请重试!',
              duration: 2000
            })
            this.loading = false
            reject(err)
          })
      })
    },
    // 从后台获取到的 url 不一定都有前缀，所以通过此函数来进行判断
    formatUrl(url) {
      if(url) {
        if(!(url.indexOf('http')>=0)) {
          return this.resourcePrefix.url + url
        }
        return url
      }
    },
    sliceUrl(url) {
      if(!(url.indexOf('http')>=0)) {
        return url
      }
      return url.slice(this.resourcePrefix.url.length)
    },
    handleOpen(){
      // 初始化一些公用数据
      // this.initData()
      // 创建 sourceDirectory 规则为 [uuid_打开这页面的时间戳]
      this.mediaUploadOptions.lovePath.source_directory = this.info.id + '_' + Date.parse(new Date()) / 1000
      // 判断编辑状态
      if (!this.isCreate) {
        // 编辑报告，使用route中的id获取form
        const id = this.viewId
        // data 中的 id，记录待使用
        this.id = parseInt(id)
        // 获取报告数据
        this.handleGetSpeechData(id)
      } else {
        // 发布报告 form 为 default form
        this.form = Object.assign({}, defaultForm)
      }
    }
  },
  computed:{
    info(){
      return this.$store.getters.getUser.info
    },
    resourcePrefix(){
      return this.$store.getters.getResourcePrefix
    }
  }
}
</script>

<style slot-scope lang="scss">

.el-form--label-top .el-form-item__label{
  padding: 0 0 0px;
}
</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-view-club/action/view-club-edit.vue